import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-starred',
  templateUrl: './starred.component.html',
  styleUrls: ['./starred.component.scss']
})
export class StarredComponent implements OnInit {

  constructor(private _dataSharingService: DataSharingService) { }

  ngOnInit(): void {
    this._dataSharingService.sendSelectedFolderDetailsFromLeftMenuFileManager(null);
  }
  

}
